import imgDontLoseYourStreak from '@assets/web-v3-images/dont-lose-your-streak.png';
import FrameActiveImg from '@assets/web-v3-images/FrameActive.png';
import FrameUnActiveImg from '@assets/web-v3-images/FrameUnActive.png';
import hammerImg from '@assets/web-v3-images/hammer.png';
import lightningImg from '@assets/web-v3-images/image.png';
import { Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import PopupFrame from '.';
import Buttons from '../Buttons';

const Items = ({ setChecked, checked, images, text, type, disabled }) => {
  const handleClick = () => {
    if (disabled) return;
    setChecked(type);
  };

  return (
    <div
      className={`relative w-full ${disabled ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
      onClick={handleClick}
    >
      <img src={checked === type ? FrameActiveImg : FrameUnActiveImg} className="w-full" />

      <div className="absolute inset-0 flex items-center justify-center gap-2 px-0 sm:px-2 md:px-2 lg:px-6 xl:px-6">
        <img src={images} className="w-8 sm:w-10 md:w-18" />
        <span
          className={`text-[13px] sm:text-[20px] font-bold ${checked === type ? 'text-[#E04F16]' : 'text-[#772917]'
            }`}
        >
          {text || ''}
        </span>
      </div>
    </div>
  );
};

export default function DontLoseYourStreak({
  open,
  onOpenChange,
  checked,
  setChecked,
  handleClick,
  days = 0,
  cost_revive_item = 0,
  cost_turn = 0,
  userTurnBalance = 0,
  userReviveItemBalance = 0,
}) {
  const { t } = useTranslation()
  return (
    <PopupFrame
      open={open}
      onOpenChange={onOpenChange}
      title={t('shwe_journey.dont_lose_your_streak')}
    >
      <div className="flex flex-col items-center justify-center">
        <Text
          as="p"
          className="text-[#A15C07] font-medium text-[13px] sm:text-[19px] text-center max-w-[100%] sm:max-w-[68%]"
        >
          {t("shwe_journey.you_missed_days_spend", { days, cost_turn, cost_revive_item })}
        </Text>

        <div className="flex justify-center px-10 sm:px-15 md:px-30 lg:px-30 xl:px-35 pt-5">
          <img
            src={imgDontLoseYourStreak}
            alt="turns"
            className="w-[120px] sm:w-[160px] md:w-[220px] lg:w-[220px] xl:w-[220px] h-auto"
          />
        </div>

        <div className="flex gap-4 justify-between mt-5 sm:mt-5 md:mt-5 lg:mt-15 xl:mt-15 pb-5">
          <Items
            setChecked={setChecked}
            images={hammerImg}
            text={t("shwe_journey.3_turns").replace("_LP_", cost_turn || 0)}
            checked={checked}
            type="TURN"
            // disabled={userTurnBalance === 0}
          />
          <Items
            setChecked={setChecked}
            images={lightningImg}
            text={t("shwe_journey.1_revive_item").replace("_LP_", cost_revive_item || 0)}
            checked={checked}
            type="REVIVE_ITEM"
            disabled={userReviveItemBalance === 0}
          />
        </div>

        <div className="px-[20%]">
          <Buttons handleClick={handleClick} textBtn={t('shwe_journey.revive')} />
        </div>
      </div>
    </PopupFrame>
  );
}
